<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <div class="save-panel">
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "holidays",
    cardSetLink: "holidays",
    item: null,
    fields: [
      {
        key: "title",
        keyLang: "title",
        label: "Название",
        isMultiLang: true,
        type: "field",
      },
      {
        key: "description",
        keyLang: "description",
        label: "Краткое описание",
        isMultiLang: true,
        type: "textarea",
      },
      {
        key: "date",
        keyLang: "date",
        label: "День",
        type: "date",
        textType: "number",
      },
    ],
  }),
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
      // if (item){
      //   this.item = item;
      // }
    },
  },
};
</script>
<style>
</style>
